<template>
  <el-dialog
    title="商户支付参数配置"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="100px"
      size="small"
    >
      <el-form-item
        prop="userCode"
        label="支付方式"
      >
        <el-radio v-model="radio" label="0"  @change="changeHandler(0)">微信</el-radio>
        <el-radio v-model="radio" label="1"  @change="changeHandler(1)">支付宝</el-radio>
        <el-radio v-model="radio" label="2" @change="changeHandler(2)">乐刷</el-radio>
        <el-radio v-model="radio" label="3" @change="changeHandler(3)">随行付</el-radio>
        <el-radio v-model="radio" label="4" @change="changeHandler(4)">银盛</el-radio>
      </el-form-item>
      <el-form-item v-if="formEdit1"
        prop="wx_rate"
        label="利率"
      >
        <el-input-number v-model="form.wx_rate" :min="0.00" :max="100" :step="0.01" :disabled="disabledStr1"></el-input-number>%
        <el-popover
                placement="top-start"
                title="温馨提示"
                width="400"
                trigger="hover"
        >
          <li>微信签约商户的费率，比如填写0.38%，则每笔交易收取商户0.38%手续费</li>
          <el-button
                  slot="reference"
                  size="mini"
                  icon="el-icon-question"
          ></el-button>
        </el-popover>
      </el-form-item>

      <el-form-item v-if="formEdit2"
                    prop="sub_merchant_number"
                    label="子商户号"
      >
        <el-input v-model="form.sub_merchant_number" :disabled="disabledStr2"></el-input>
      </el-form-item>


      <el-form-item v-if="formEdit3"
                    prop="zfb_rate"
                    label="利率"
      >
        <el-input-number v-model="form.zfb_rate" :min="0.00" :max="100" :step="0.01" :disabled="disabledStr3"></el-input-number>%
        <el-popover
                placement="top-start"
                title="温馨提示"
                width="400"
                trigger="hover"
        >
          <li>支付宝签约商户的费率，比如填写0.38%，则每笔交易收取商户0.38%手续费</li>
          <el-button
                  slot="reference"
                  size="mini"
                  icon="el-icon-question"
          ></el-button>
        </el-popover>
      </el-form-item>

      <el-form-item v-if="formEdit4"
                    prop="zfb_token"
                    label="授权token"
      >
        <el-input v-model="form.zfb_token" :disabled="disabledStr4"></el-input>
      </el-form-item>
      <el-form-item v-if="formEdit5"
                    prop="zfb_pid"
                    label="pid"
      >
        <el-input v-model="form.zfb_pid" :disabled="disabledStr5"></el-input>
      </el-form-item>
      <el-form-item v-if="formEdit6"
                    prop="fy_wx_rate"
                    label="微信利率"
      >
        <el-input-number v-model="form.fy_wx_rate" :min="0.00" :max="100" :step="0.01" :disabled="disabledStr6"></el-input-number>%
        <el-popover
                placement="top-start"
                title="温馨提示"
                width="400"
                trigger="hover"
        >
          <li>乐刷微信通道签约商户的费率，比如填写0.38%，则每笔交易收取商户0.38%手续费</li>
          <el-button
                  slot="reference"
                  size="mini"
                  icon="el-icon-question"
          ></el-button>
        </el-popover>
      </el-form-item>

      <el-form-item v-if="formEdit7"
                    prop="fy_zfb_rate"
                    label="支付宝利率"
      >
        <el-input-number v-model="form.fy_zfb_rate" :min="0.00" :max="100" :step="0.01" :disabled="disabledStr7"></el-input-number>%
        <el-popover
                placement="top-start"
                title="温馨提示"
                width="400"
                trigger="hover"
        >
          <li>乐刷支付宝通道签约商户的费率，比如填写0.38%，则每笔交易收取商户0.38%手续费</li>
          <el-button
                  slot="reference"
                  size="mini"
                  icon="el-icon-question"
          ></el-button>
        </el-popover>
      </el-form-item>

      <el-form-item v-if="formEdit8"
                    prop="fy_merchant_number"
                    label="商户号"
      >
        <el-input v-model="form.fy_merchant_number" :disabled="disabledStr8"></el-input>
      </el-form-item>

      <el-form-item v-if="formEdit9"
                    prop="sxf_wx_rate"
                    label="微信利率"
      >
        <el-input-number v-model="form.sxf_wx_rate" :min="0.00" :max="100" :step="0.01" :disabled="disabledStr9"></el-input-number>%
        <el-popover
                placement="top-start"
                title="温馨提示"
                width="400"
                trigger="hover"
        >
          <li>随行付微信通道签约商户的费率，比如填写0.38%，则每笔交易收取商户0.38%手续费</li>
          <el-button
                  slot="reference"
                  size="mini"
                  icon="el-icon-question"
          ></el-button>
        </el-popover>
      </el-form-item>

      <el-form-item v-if="formEdit10"
                    prop="sxf_zfb_rate"
                    label="支付宝利率"
      >
        <el-input-number v-model="form.sxf_zfb_rate" :min="0.00" :max="100" :step="0.01" :disabled="disabledStr10"></el-input-number>%
        <el-popover
                placement="top-start"
                title="温馨提示"
                width="400"
                trigger="hover"
        >
          <li>随行付支付宝通道签约商户的费率，比如填写0.38%，则每笔交易收取商户0.38%手续费</li>
          <el-button
                  slot="reference"
                  size="mini"
                  icon="el-icon-question"
          ></el-button>
        </el-popover>
      </el-form-item>

      <el-form-item v-if="formEdit11"
                    prop="sxf_merchant_code"
                    label="商户编码"
      >
        <el-input v-model="form.sxf_merchant_code" :disabled="disabledStr11"></el-input>
      </el-form-item>



      <el-form-item v-if="formEdit12"
                    prop="ys_wx_rate"
                    label="微信利率"
      >
        <el-input-number v-model="form.ys_wx_rate" :min="0.00" :max="100" :step="0.01" :disabled="disabledStr12"></el-input-number>%
        <el-popover
                placement="top-start"
                title="温馨提示"
                width="400"
                trigger="hover"
        >
          <li>银盛微信通道签约商户的费率，比如填写0.38%，则每笔交易收取商户0.38%手续费</li>
          <el-button
                  slot="reference"
                  size="mini"
                  icon="el-icon-question"
          ></el-button>
        </el-popover>
      </el-form-item>

      <el-form-item v-if="formEdit13"
                    prop="ys_zfb_rate"
                    label="支付宝利率"
      >
        <el-input-number v-model="form.ys_zfb_rate" :min="0.00" :max="100" :step="0.01" :disabled="disabledStr13"></el-input-number>%
        <el-popover
                placement="top-start"
                title="温馨提示"
                width="400"
                trigger="hover"
        >
          <li>银盛支付宝通道签约商户的费率，比如填写0.38%，则每笔交易收取商户0.38%手续费</li>
          <el-button
                  slot="reference"
                  size="mini"
                  icon="el-icon-question"
          ></el-button>
        </el-popover>
      </el-form-item>

      <el-form-item v-if="formEdit14"
                    prop="ys_merchant_code"
                    label="商户编码"
      >
        <el-input v-model="form.ys_merchant_code" :disabled="disabledStr14"></el-input>
      </el-form-item>
      <el-form-item v-if="formEdit15"
                    prop="ys_key"
                    label="key密钥"
      >
        <el-input v-model="form.ys_key" :disabled="disabledStr4"></el-input>
      </el-form-item>


      <el-form-item>
        <el-button @click="close">取消</el-button>
        <el-button @click="pzgl">配置</el-button>
        <el-button
          type="primary"
          :loading="loading"
          @click="saveUser"
        >保存</el-button>

      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<script>
    import * as agentService from "@/api/sys/agent";
    import * as userService from "@/api/sys/user";
    import util from '@/libs/util.js'
export default {
  name: "payparameterEditForm",
  props: {
      agent: Object,
      accuseVisible:Boolean,
    value: Boolean
  },
  data() {
    return {
        radio: '0',
        formEdit1: true,
        accuseVisible2:true,
        formEdit2: true,
      loading: false,
      dialogVisible: false,

      form: {
          sub_merchant_number:'',
          zfb_token: '',
          zfb_pid: '',
          fy_merchant_number: '',
          sxf_merchant_code: '',
          ys_merchant_code: '',
          ys_key: ''
      },
        formEdit3:false,
        formEdit4:false,
        formEdit5:false,
        formEdit6:false,
        formEdit7:false,
        formEdit8:false,
        formEdit9:false,
        formEdit10:false,
        formEdit11:false,
        formEdit12:false,
        formEdit13:false,
        formEdit14:false,
        formEdit15:false,
        disabledStr1:true,
        disabledStr2:true,
        disabledStr3:true,
        disabledStr4:true,
        disabledStr5:true,
        disabledStr6:true,
        disabledStr7:true,
        disabledStr8:true,
        disabledStr9:true,
        disabledStr10:true,
        disabledStr11:true,
        disabledStr12:true,
        disabledStr13:true,
        disabledStr14:true,
        disabledStr15:true
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
      accuseVisible (newValue, oldValue) {
          console.log("-----"+newValue);
          this.accuseVisible2 = newValue;
      },

      dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    dialogOpen() {
        this.form = {};
        this.disabledStr1=true;
            this.disabledStr2=true;
            this.disabledStr3=true;
            this.disabledStr4=true;
            this.disabledStr5=true;
            this.disabledStr6=true;
            this.disabledStr7=true;
            this.disabledStr8=true;
            this.disabledStr9=true;
            this.disabledStr10=true;
            this.disabledStr11=true;
            this.disabledStr12=true;
            this.disabledStr13=true;
            this.disabledStr14=true;
            this.disabledStr15=true;
        var formData4 = new FormData() // 声明一个FormData对象
        formData4.append("agentid",this.agent.agentid);
        agentService.getConfigureAgent(formData4).then(data => {
            if(data!=null && data!=""){
                let form = {};
                if(data.wx_rate!=null && data.wx_rate!="") {
                    form.wx_rate = data.wx_rate;
                }
                if(data.sub_merchant_number!=null && data.sub_merchant_number!="") {
                    form.sub_merchant_number = data.sub_merchant_number;
                }
                if(data.zfb_rate!=null && data.zfb_rate!="") {
                    console.info("data.zfb_rate===="+data.zfb_rate);
                    form.zfb_rate = data.zfb_rate;
                }
                if(data.zfb_token!=null && data.zfb_token!="") {
                    form.zfb_token = data.zfb_token;
                }
                if(data.zfb_pid!=null && data.zfb_pid!="") {
                    form.zfb_pid = data.zfb_pid;
                }
                if(data.fy_wx_rate!=null && data.fy_wx_rate!="") {
                    form.fy_wx_rate = data.fy_wx_rate;
                }
                if(data.fy_zfb_rate!=null && data.fy_zfb_rate!="") {
                    form.fy_zfb_rate = data.fy_zfb_rate;
                }
                if(data.fy_merchant_number!=null && data.fy_merchant_number!="") {
                    form.fy_merchant_number = data.fy_merchant_number;
                }
                if(data.sxf_wx_rate!=null && data.sxf_wx_rate!="") {
                    form.sxf_wx_rate = data.sxf_wx_rate;
                }

                if(data.sxf_zfb_rate!=null && data.sxf_zfb_rate!="") {
                    form.sxf_zfb_rate = data.sxf_zfb_rate;
                }
                if(data.sxf_merchant_code!=null && data.sxf_merchant_code!="") {
                    form.sxf_merchant_code = data.sxf_merchant_code;
                }
                if(data.ys_wx_rate!=null && data.ys_wx_rate!="") {
                    form.ys_wx_rate = data.ys_wx_rate;
                }
                if(data.ys_zfb_rate!=null && data.ys_zfb_rate!="") {
                    form.ys_zfb_rate = data.ys_zfb_rate;
                }
                if(data.ys_merchant_code!=null && data.ys_merchant_code!="") {
                    form.ys_merchant_code = data.ys_merchant_code;
                }
                if(data.ys_key!=null && data.ys_key!="") {
                    form.ys_key = data.ys_key;
                }

                this.form = form;


            }
        });

    },
      pzgl(){
         this.disabledStr1=false;
          this.disabledStr2=false;
          this.disabledStr3=false;
          this.disabledStr4=false;
          this.disabledStr5=false;
          this.disabledStr6=false;
          this.disabledStr7=false;
          this.disabledStr8=false;
          this.disabledStr9=false;
          this.disabledStr10=false;
          this.disabledStr11=false;
          this.disabledStr12=false;
          this.disabledStr13=false;
          this.disabledStr14=false;
          this.disabledStr15=false;

      },
      changeHandler(val){
          if(val==0){
              this.formEdit1=true;
              this.formEdit2=true;
              this.formEdit3=false;
              this.formEdit4=false;
              this.formEdit5=false;
              this.formEdit6=false;
              this.formEdit7=false;
              this.formEdit8=false;
              this.formEdit9=false;
              this.formEdit10=false;
              this.formEdit11=false;
              this.formEdit12=false;
              this.formEdit13=false;
              this.formEdit14=false;
              this.formEdit15=false;

          }else if(val==1){
              this.formEdit1=false;
              this.formEdit2=false;
              this.formEdit3=true;
              this.formEdit4=true;
              this.formEdit5=true;
              this.formEdit6=false;
              this.formEdit7=false;
              this.formEdit8=false;
              this.formEdit9=false;
              this.formEdit10=false;
              this.formEdit11=false;
              this.formEdit12=false;
              this.formEdit13=false;
              this.formEdit14=false;
              this.formEdit15=false;
          }else if(val==2){
              this.formEdit1=false;
              this.formEdit2=false;
              this.formEdit3=false;
              this.formEdit4=false;
              this.formEdit5=false;
              this.formEdit6=true;
              this.formEdit7=true;
              this.formEdit8=true;
              this.formEdit9=false;
              this.formEdit10=false;
              this.formEdit11=false;
              this.formEdit12=false;
              this.formEdit13=false;
              this.formEdit14=false;
              this.formEdit15=false;
          }else if(val==3){
              this.formEdit1=false;
              this.formEdit2=false;
              this.formEdit3=false;
              this.formEdit4=false;
              this.formEdit5=false;
              this.formEdit6=false;
              this.formEdit7=false;
              this.formEdit8=false;
              this.formEdit9=true;
              this.formEdit10=true;
              this.formEdit11=true;
              this.formEdit12=false;
              this.formEdit13=false;
              this.formEdit14=false;
              this.formEdit15=false;
          }else if(val==4){
              this.formEdit1=false;
              this.formEdit2=false;
              this.formEdit3=false;
              this.formEdit4=false;
              this.formEdit5=false;
              this.formEdit6=false;
              this.formEdit7=false;
              this.formEdit8=false;
              this.formEdit9=false;
              this.formEdit10=false;
              this.formEdit11=false;
              this.formEdit12=true;
              this.formEdit13=true;
              this.formEdit14=true;
              this.formEdit15=true;
          }
      },
    saveUser() {
      this.$refs["form"].validate(valid => {
        if (valid) {
                this.loading = true;
                agentService.AgentSaveConfigure({ ...this.form,agentid:this.agent.agentid})
                    .then(data => {
                        this.loading = false;
                        this.dialogVisible = false;
                        this.$emit("submit");
                    });

        } else {
          return false;
        }
      });
    },
    close() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>

